import React, { Component } from 'react';
import $ from 'jquery';

class ChangeRegionModal extends Component{

    constructor(props) {
        super(props);

        this.state = {
            region: '',
        };
    };

    componentDidMount(): void {
        this.closeAction();
    }

    closeConfirm = async () => {        
        const { NoChangeRegion } = this.props;
        NoChangeRegion();
    }

    closeAction = () => {
        $('#changeRegionModal').on('hidden.bs.modal', function () {
        });
    };

    Continue =()=>{
        const { empleado, toggleCostumer, selectClient, selectempleado } = this.props;
        if(empleado === 2){
            toggleCostumer();
        }else{
            selectClient(selectempleado);
        }      
        
        $('#changeRegionModal').modal('hide');  
    }

    render() {
        const {change} = this.props;
        return (
                <div class="modal" tabindex="-1" role="dialog" id="changeRegionModal" >
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                        <div class="modal-body">
                            <p>¿Deseas cambiar tu región?</p>
                            <select id="Selectactiva" class="form-control btn-outline-secondary"
                                    style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                    onChange={(event) => change(event)}>
                                <option value=''>--Seleccionar Región--</option>
                                <option value='2010'>2010 - Lima</option>
                                <option value='2020'>2020 - Trujillo</option>
                                <option value='2030'>2030 - Chiclayo</option>
                                <option value='2060'>2060 - Arequipa</option>
                            </select>
                        </div>
                        <div class="modal-footer">
                            <button type="button" className="btn btn-success" onClick={this.Continue}> Cambiar </button>
                            <button type="button" className="btn btn-danger" onClick={this.closeConfirm}>No</button>
                        </div>
                        </div>
                    </div>
                </div>
        );  
    }
}
export default ChangeRegionModal;